import { c as _c } from "react/compiler-runtime";
import React from 'react';
import { useTranslations } from 'next-intl';
import NextImage from 'next/image';
import buildRouteUrl from '../../helpers/buildRouteUrl';
import { Link } from '../../i18n/navigation';
import { Credit } from '../../types/types';
interface PropTypes {
  data: Credit;
}
function Person(t0) {
  const $ = _c(22);
  const {
    data
  } = t0;
  const t = useTranslations();
  const t1 = `/person/${data._id}`;
  let t2;
  if ($[0] !== t1) {
    t2 = buildRouteUrl(t1);
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const href = t2;
  const t3 = `https://cdn-proxy.trakio.app/t/p/w220_and_h330_face${data.avatar}`;
  let t4;
  if ($[2] !== data.name || $[3] !== t) {
    t4 = t("images_alts.person_image", {
      name: data.name
    });
    $[2] = data.name;
    $[3] = t;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== t3 || $[6] !== t4) {
    t5 = <NextImage className="rounded-md bg-gray-400 hover:opacity-[0.4] transition-all duration-200 w-[100px] md:w-[140px] min-w-[100px] md:min-w-[140px] h-[150px] md:h-[210px] min-h-[150px] md:min-h-[210px]" src={t3} alt={t4} width={140} height={210} sizes={"\n          (min-width: 300px) 100px,150px\n          (min-width: 768px) 140px,210px"} unoptimized={true} />;
    $[5] = t3;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== href || $[9] !== t5) {
    t6 = <Link href={href} about="">{t5}</Link>;
    $[8] = href;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== data.name) {
    t7 = <span className="text-center text-white font-bold mt-2 w-full line-clamp-1">{data.name}</span>;
    $[11] = data.name;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== href || $[14] !== t7) {
    t8 = <Link href={href}>{t7}</Link>;
    $[13] = href;
    $[14] = t7;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== data.character) {
    t9 = data.character && <span className="text-center text-white w-[100px] md:w-[140px] line-clamp-2">{data.character}</span>;
    $[16] = data.character;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== t6 || $[19] !== t8 || $[20] !== t9) {
    t10 = <div className="flex flex-col justify-center items-center mr-2">{t6}{t8}{t9}</div>;
    $[18] = t6;
    $[19] = t8;
    $[20] = t9;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  return t10;
}
export default Person;